import templateUrl from './report-edit.html';

export const reportEditComponent = {
    bindings: {
        details: '<',
        menuName: '@',
        slugUrl: '@',
        parentSlug: '@'
    },

    templateUrl,

    controller: class ReportEditComponent {
        constructor($state, ReportEditService, toastr, ModalService, CompareObjectService, DynamicMenusService, SlugService) {
            'ngInject';

            this.$state = $state;
            this.reportEditService = ReportEditService;
            this.toastr = toastr;
            this.modalService = ModalService;
            this.compareObjectService = CompareObjectService;
            this.dynamicMenusService = DynamicMenusService;
            this.slugService = SlugService;
        }

        $onInit() {
            this.serviceAreaList = [];
            this.programYears = [];
            this.isShortDetails = this._isShortDetailsHaveReport();
            this._getServiceAreaList();
            this._getProgramYearList();

            this.details = this.reportEditService.getReportDetailsObject(this.details);
            this.saveData = angular.copy(this.details);
        }

        onSubmit(details) {
            this.disableButtons = true;
            const url = this.slugService.removeResourceActionsFromSlugURL(this.slugUrl, 'edit');
            details = this.reportEditService.setProgressReportDetailsData(details);

            this.dynamicMenusService.updateMenuDetailsByUrl(this.slugUrl, details)
                .then((details) => {
                    const contentDetailsUrl = this.slugService.getDetailsPageURL(url);
                    this.toastr.success('data updated successfully');
                    this._redirectToParentState(contentDetailsUrl);
                }).catch((err) => {
                    this.toastr.error(err);
                    this.disableButtons = false
                });
        }

        onCancel(details) {
            const _details = angular.copy(details);
            const isUpdated = details ? this.compareObjectService.deepCompareObjectHasChanged(this.saveData, _details, true) : false;
            if (isUpdated) {
                this.modalService.open({
                    details: {
                        bodyMessage: 'Changes done will be reverted. Continue?'
                    },
                    buttons: [{
                        name: 'No'
                    }, {
                        name: 'Yes',
                        isPrimary: true,
                        action: _onSubmit.bind(this)
                    }]
                });
            } else {
                this._redirectToParentState(this.parentSlug);
            }

            function _onSubmit() {
                this._redirectToParentState(this.parentSlug);
            }
        }

        _redirectToParentState(slug) {
            this.$state.go('app.dashboard.DynamicMenus', {
                url: slug
            });
        }

        _getServiceAreaList() {
            this.reportEditService.getServiceAreaList()
                .then(list => {
                    this.serviceAreaList = angular.copy(list);
                    this._addAllCountyOption();
                });
        }

        _addAllCountyOption() {
            this.serviceAreaList.unshift({
                id: -1,
                name: 'All County'
            });
        }

        _isShortDetailsHaveReport() {
            return this.menuName === 'ProgressReportsEdit' ? false : true;
        }

        _getProgramYearList() {
            this.reportEditService.getPrgoramYears()
                .then(years => this.programYears = years);
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/components/report-edit/report-edit.component.js